import { render } from "./MonthInvoicePDFPage.vue?vue&type=template&id=45a7629e&ts=true"
import script from "./MonthInvoicePDFPage.vue?vue&type=script&lang=ts"
export * from "./MonthInvoicePDFPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__